// TODO: write documentation for colors and palette in own markdown file and add links from here

const palette = {
  neutral100: "#FFFFFF",
  neutral200: "#F4F2F1",
  neutral300: "#D7CEC9",
  neutral400: "#B6ACA6",
  neutral500: "#978F8A",
  neutral600: "#564E4A",
  neutral700: "#3C3836",
  neutral800: "#191015",
  neutral900: "#000000",

  // primary: "#FF6C2D",
  // primary: "#FFDA44",
  primary: "#62a1b4",
  primary100: "#F4E0D9",
  primary200: "#E8C1B4",
  primary300: "#DDA28E",
  primary400: "#D28468",
  primary500: "#C76542",
  primary600: "#A54F31",

  secondary100: "#DCDDE9",
  secondary200: "#BCC0D6",
  secondary300: "#9196B9",
  secondary400: "#626894",
  secondary500: "#41476E",

  accent100: "#FFEED4",
  accent200: "#FFE1B2",
  accent300: "#FDD495",
  accent400: "#FBC878",
  accent500: "#FFBB50",

  angry100: "#F2D6CD",
  angry500: "#C03403",

  overlay20: "rgba(25, 16, 21, 0.2)",
  overlay50: "rgba(25, 16, 21, 0.5)",
} as const

export const colors = {
  /**
   * The palette is available to use, but prefer using the name.
   * This is only included for rare, one-off cases. Try to use
   * semantic names as much as possible.
   */
  palette,
  primary: "#F48120",
  /**
   * A helper for making something see-thru.
   */
  transparent: "rgba(0, 0, 0, 0)",
  /**
   * The default text color in many components.
   */
  text: palette.neutral800,
  /**
   * Secondary text information.
   */
  textDim: palette.neutral600,
  /**
   * The default color of the screen background.
   */
  background: palette.neutral200,
  /**
   * The default border color.
   */
  border: palette.neutral400,
  /**
   * The main tinting color.
   */
  tint: palette.primary500,
  /**
   * A subtle color used for lines.
   */
  separator: palette.neutral300,
  /**
   * Error messages.
   */
  error: "red",
  errorText: "red",
  /**
   * Error Background.
   *
   */
  errorBackground: palette.angry100,

  white: "white",
  black: "black",
  passwordIcon: "rgba(0,0,0,0.3)",
  inputFieldBackground: "white",
  inputFieldBorder: "#d7d7d7",
  placeholder: "rgba(0,0,0,0.3)",
  whitePlaceholder: "rgba(255,255,255,0.2)",
  pivilegePointContainer: "rgba(0,0,0,0.15)",
  green: "#00C087",

  hyperlink: "#1877f2",
  lightGrey: "rgba(35,35,35,0.5)",
  lightestGrey: "#FAFAFA",
  carouselPAgination: "#EFEFEF",
  headerFirstLinearGradient: "#FF6C2D",
  headerSecondLinearGradient: "#FF1B5F",
  headerShadow: "#FF4B42",
  headerNameBg: "#EFEFEF",
  lighterGrey: "#EFEFEF",
  darkerGrey: "#808080",

  // This is used for setting linear color for whole project.
  linearFirstColor: "#265A97",
  linearSecondColor: "#9cc8ff",
  buttonBackground: "green",
  buttonTitle: "white",

  mainBgColor: "#D3D3D3",
  appMaxWidth: 800,
}
